export default {
  API_ENDPOINT: `https://whispering-tundra-52779.herokuapp.com`, //|| `http://localhost:8000/api`,
  API_KEY: process.env.REACT_APP_KEY
}
